
import React from 'react';
import Button from '../../../components/base/Button';

const ProductsSection: React.FC = () => {
  const products = [
    {
      title: 'Executive Desks',
      description: 'Premium executive desks designed for leadership and productivity',
      image: 'https://public.readdy.ai/ai/img_res/32e40afb18d526bb23ba06d631879282.jpg',
      features: ['Premium Materials', 'Built-in Storage', 'Cable Management']
    },
    {
      title: 'Ergonomic Chairs',
      description: 'Comfortable seating solutions for all-day productivity',
      image: 'https://readdy.ai/api/search-image?query=High-quality%20ergonomic%20office%20chair%20with%20lumbar%20support%2C%20adjustable%20height%2C%20premium%20fabric%20upholstery%2C%20and%20modern%20design%20on%20clean%20white%20background%20showcasing%20professional%20furniture&width=400&height=300&seq=ergonomic-chair&orientation=landscape',
      features: ['Lumbar Support', 'Adjustable Height', 'Breathable Fabric']
    },
    {
      title: 'Conference Tables',
      description: 'Professional meeting spaces for collaboration and decision-making',
      image: 'https://readdy.ai/api/search-image?query=Large%20modern%20conference%20table%20with%20sleek%20design%2C%20premium%20wood%20or%20glass%20surface%2C%20surrounded%20by%20executive%20chairs%20in%20a%20bright%20professional%20meeting%20room%20with%20clean%20background&width=400&height=300&seq=conference-table&orientation=landscape',
      features: ['Various Sizes', 'Cable Integration', 'Durable Construction']
    },
    {
      title: 'Storage Solutions',
      description: 'Organized storage systems for efficient office management',
      image: 'https://readdy.ai/api/search-image?query=Modern%20office%20storage%20cabinets%20and%20filing%20systems%20with%20clean%20lines%2C%20multiple%20compartments%2C%20and%20professional%20finish%20in%20a%20contemporary%20office%20environment%20with%20white%20background&width=400&height=300&seq=storage-solutions&orientation=landscape',
      features: ['Modular Design', 'Secure Locking', 'Space Efficient']
    },
    {
      title: 'Reception Furniture',
      description: 'Create impressive first impressions with elegant reception areas',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20reception%20desk%20and%20seating%20area%20with%20modern%20design%2C%20comfortable%20chairs%2C%20and%20professional%20appearance%20in%20a%20bright%20office%20lobby%20with%20clean%20contemporary%20styling&width=400&height=300&seq=reception-furniture&orientation=landscape',
      features: ['Welcoming Design', 'Durable Materials', 'Brand Integration']
    },
    {
      title: 'Workstations',
      description: 'Collaborative workspaces designed for modern teams',
      image: 'https://readdy.ai/api/search-image?query=Modern%20office%20workstation%20pods%20with%20multiple%20desks%2C%20privacy%20panels%2C%20and%20collaborative%20design%20in%20an%20open%20office%20environment%20with%20clean%20professional%20styling%20and%20white%20background&width=400&height=300&seq=workstations&orientation=landscape',
      features: ['Privacy Panels', 'Collaborative Design', 'Flexible Layout']
    }
  ];

  return (
    <section className="py-20 bg-white" data-product-shop>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Premium <strong>Office Furniture</strong> Collection
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover our extensive range of high-quality office furniture designed to enhance productivity, 
            comfort, and style in your South Carolina workspace.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-product-shop>
          {products.map((product, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 border border-gray-100" data-product-shop>
              <div className="h-48 bg-cover bg-center object-top" style={{ backgroundImage: `url('${product.image}')` }}></div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{product.title}</h3>
                <p className="text-gray-600 mb-4">{product.description}</p>
                <ul className="space-y-1 mb-4">
                  {product.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-600">
                      <i className="ri-check-line text-green-500 mr-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                <Button variant="outline" size="sm" href="/quote" className="w-full">
                  Request Quote
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
